import { useApi, useDomLoaded, useIsMobile } from '@cleartax/wg-library-hooks';
import { useEffect } from 'react';
import { THeader } from '../../../../../pages/services/[planSeoSlug]/api/types';
import { useUserCtx } from '../../../../context/user';
import { HeaderLogo } from '../utils';
import { CategoryNavbarButtonDesktop } from './category-dropwdown/category-dropdown-desktop-button';
import { getHeaderDetails } from './header.api';
import { LoggedInSection, LoggedOutSection } from './logged-in-out';
import { MobileHeader } from './mobile-header';
import { Search } from './search/index.component';

export const DefaultHeader = () => {
  const { request: getHeaderData, data: headerData } = useApi<THeader>(
    [],
    getHeaderDetails,
    true
  );
  const isMobile = useIsMobile();
  const isDomLoaded = useDomLoaded();

  const userContext = useUserCtx();

  useEffect(() => {
    getHeaderData();
  }, []);

  if (!isDomLoaded) return <></>;
  return (
    <header className="w-full h-20 sticky top-0 bg-white z-50 sm:h-12">
      {/* Desktop */}
      <div className="wg-container flex h-full items-center sm:justify-between sm:hidden">
        <HeaderLogo />
        <div className="flex w-full justify-between items-center sm:hidden">
          <div className="flex">
            <CategoryNavbarButtonDesktop
              category="individual"
              headerData={headerData}
            />
            <CategoryNavbarButtonDesktop
              category="business"
              headerData={headerData}
              className={'text-brand-1000'}
              dropdownClassName={
                'origin-top-right absolute sm:relative -left-32 mt-2 rounded-lg shadow-md sm:shadow-none focus:outline-none'
              }
            />
          </div>
          <Search />
          <div className="flex items-center">
            {userContext.isLoggenIn ? (
              <LoggedInSection />
            ) : (
              <LoggedOutSection />
            )}
          </div>
        </div>
      </div>
      {/* Mobile */}
      {isMobile ? <MobileHeader headerData={headerData} /> : null}
    </header>
  );
};
